import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const GELSymbolIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <path
        d="M11.4982 3.5C11.9124 3.50008 12.2482 3.83584 12.2482 4.25V5.03418C13.3371 5.45975 14.1144 6.18868 14.6447 7.02539C15.4571 8.30742 15.6623 9.79041 15.6623 10.6982C15.6622 11.1122 15.3263 11.448 14.9123 11.4482C14.4982 11.4482 14.1624 11.1123 14.1623 10.6982C14.1623 9.96258 13.9877 8.7902 13.3781 7.82813C13.1074 7.40092 12.7436 7.00507 12.2482 6.70313V10.3193C12.2479 10.7332 11.9122 11.0693 11.4982 11.0693C11.0842 11.0693 10.7486 10.7332 10.7482 10.3193V6.18945C10.51 6.15637 10.2547 6.13771 9.98066 6.1377C9.71163 6.13772 9.45565 6.15695 9.21309 6.19336V10.3193C9.21273 10.7332 8.87708 11.0693 8.46309 11.0693C8.04932 11.0691 7.71344 10.7331 7.71309 10.3193V6.72363C7.40772 6.91012 7.13985 7.13578 6.90938 7.39355C6.21197 8.17373 5.8 9.31064 5.8 10.6982C5.80004 12.0222 6.10171 13.0459 6.71113 13.7334C7.30549 14.4036 8.30462 14.8788 9.98066 14.8789H14.9123C15.3263 14.8791 15.6622 15.2149 15.6623 15.6289C15.6623 16.043 15.3263 16.3787 14.9123 16.3789H5.05C4.63579 16.3789 4.3 16.0431 4.3 15.6289C4.3001 15.2148 4.63585 14.8789 5.05 14.8789H5.73164C5.68326 14.8293 5.63512 14.7795 5.58906 14.7275C4.64346 13.6608 4.30004 12.2189 4.3 10.6982C4.3 9.02024 4.80011 7.50214 5.79121 6.39355C6.31633 5.80623 6.9638 5.35209 7.71309 5.05273L7.71406 4.25C7.71406 3.83579 8.04985 3.5 8.46406 3.5C8.87805 3.50026 9.21406 3.83595 9.21406 4.25L9.21309 4.68164C9.46173 4.65328 9.71783 4.63771 9.98066 4.6377C10.2479 4.6377 10.5035 4.65259 10.7482 4.67871V4.25C10.7482 3.83579 11.084 3.5 11.4982 3.5Z"
        fill="#888888"/>
    </svg>
  );
};
